import { RG_TYPE as o } from "@project-rouge/rg-core";
const t = {
  [o.Wall]: { color: "white", strokeColor: "black", strokeWidth: 0.03 },
  [o.Opening]: { color: "white", strokeColor: "white", strokeWidth: 0.03, secondaryStrokeColor: "black", secondaryStrokeWidth: 0.03 },
  [o.Window]: { color: "white", strokeColor: "black", strokeWidth: 0.01 },
  [o.Door]: { color: "white", strokeColor: "black", strokeWidth: 0.01 },
  [o.Floor]: { color: "white", strokeColor: "black", strokeWidth: 0.03 },
  [o.Ceiling]: { color: "white", strokeColor: "black", strokeWidth: 0.03 },
  [o.Beam]: { color: "white", strokeColor: "black", strokeWidth: 0.03 }
};
export {
  t as ElevationViewStyle
};
//# sourceMappingURL=index.js.map
